import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcDocumentWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 7C8 5.89543 8.89543 5 10 5H19.608C20.7126 5 21.608 5.89543 21.608 7V19.632C21.608 20.7366 20.7126 21.632 19.608 21.632H10C8.89543 21.632 8 20.7366 8 19.632V7Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.51208 10C5.51208 8.89543 6.40752 8 7.51208 8H17.1201C18.2247 8 19.1201 8.89543 19.1201 10V22.632C19.1201 23.7366 18.2247 24.632 17.1201 24.632H7.51208C6.40752 24.632 5.51208 23.7366 5.51208 22.632V10Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.5 12.3H8V11.7H16.5V12.3ZM14 14.3H8V13.7H14V14.3ZM8 16.3H14V15.7H8V16.3Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.096 21.6079H4C4 23.4223 4.378 24.2539 5.512 24.6319H17.608C17.608 24.6319 16.096 23.8759 16.096 21.6079Z",
			fill: "#C4D7FD"
		})
	]
});
export default SvgIcDocumentWhite;
